<template>
    <SignaloDialog
        :icon="'mdi-table-cog'"
        :title="$t('common.manageVisibleColumns')"
        :open="true"
        @close="$emit('close')"
    >
        <template #body>
            <v-card-text>
                <table class="table-columns-visibility-table">
                    <thead>
                        <tr>
                            <th class="table-columns-visibility-table-header">
                                {{ $t('common.columnName') }}
                            </th>
                            <th class="table-columns-visibility-table-header">
                                {{ $t('common.visible') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="column in tableHeadersOptions"
                            :key="column.value"
                        >
                            <td>{{ column.text }}</td>
                            <td>
                                <v-switch
                                    hide-details
                                    inset
                                    color="primary"
                                    :modelValue="column.visible"
                                    :loading="loading"
                                    :disabled="loading"
                                    @click.stop="
                                        patchColumnVisibility(
                                            column.value,
                                            column.visible
                                        )
                                    "
                                ></v-switch>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
        </template>

        <template #buttons><div></div></template>
    </SignaloDialog>
</template>

<script>
import { getTableHeaders } from '@/CONSTANTS/tableHeaders/tableHeaders';
import * as AUTH_STORE from 'signalo-vue-auth-store';
import * as HELPERS_STORE from 'signalo-vue-helpers-store';
export default {
    setup() {
        const authStore = AUTH_STORE.default();
        const helpersStore = HELPERS_STORE.default();
        return { authStore, helpersStore };
    },
    emits: ['close'],
    props: {
        tableName: {
            type: String,
            requred: true,
        },
    },
    data() {
        return {
            tableHeadersOptions: [],
            loading: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loading = true;
            const tableUserPreferences =
                this.authStore.user.attributes?.[this.tableName] || [];
            this.tableHeadersOptions = getTableHeaders(this.tableName)
                .filter((th) => th.text)
                .map((th) => {
                    return {
                        value: th.value,
                        text: th.text,
                        visible:
                            tableUserPreferences[th.value]?.visible !==
                            undefined
                                ? tableUserPreferences[th.value]?.visible
                                : true,
                    };
                });
            this.loading = false;
        },
        async patchColumnVisibility(columnValue, visible) {
            this.loading = true;
            const preferences = {};
            preferences[columnValue] = { visible: !visible };
            await this.authStore.patchTablePreferences(
                this.tableName,
                preferences
            );
            await this.authStore.getAuth();
            this.init();
            this.helpersStore.snackbarSaved();
            this.loading = false;
        },
    },
};
</script>

<style scoped>
th.table-columns-visibility-table-header {
    border: none;
}

.table-columns-visibility-table tr td:last-of-type,
.table-columns-visibility-table tr th:last-of-type {
    padding-left: 32px;
}
</style>
